import React from 'react';
import { CButton, CSpinner } from '@coreui/react';

function LoaderButton(props) {
  const { onClick, loading, title, type = 'button', ...rest } = props;
  return (
    <CButton color="primary" onClick={onClick} type={type} {...rest}>
      {loading && <CSpinner grow size="sm" className="mr-2" />}
      {title}
    </CButton>
  );
}

export default LoaderButton;
